import { IPayout } from '@/store/models/payout.model';

import { IBaseAction, IBaseState, TAppError } from '@/store/types/base.state';

export enum PayoutActionTypes {
  MAKE_PAYOUT = 'PAYOUT.MAKE_PAYOUT',
  MAKE_PAYOUT_SUCCESS = 'PAYOUT.MAKE_PAYOUT_SUCCESS',
  MAKE_PAYOUT_FAIL = 'PAYOUT.MAKE_PAYOUT_FAIL',
}

export interface IMakePayoutAction extends IBaseAction {
  type: typeof PayoutActionTypes.MAKE_PAYOUT;
}

export interface IMakePayoutSuccessAction extends IBaseAction {
  type: typeof PayoutActionTypes.MAKE_PAYOUT_SUCCESS;
  payout: IPayout;
}

export interface IMakePayoutFailAction extends IBaseAction {
  type: typeof PayoutActionTypes.MAKE_PAYOUT_FAIL;
  error: TAppError;
}

export type TPayoutAction = IMakePayoutAction | IMakePayoutSuccessAction | IMakePayoutFailAction;

export interface IPayoutState extends IBaseState {
  payout: IPayout | null;
}
